var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTournamentTicketFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 11c0 .038 0 .076.002.114-.452-.125-.65-.314-.753-.468-.145-.218-.207-.502-.232-.896h.983V11zM14.748 11.114c.452-.125.65-.314.753-.468.145-.218.207-.502.232-.896h-.983V11c0 .038 0 .076-.002.114zM10.75 8.75V11a1.25 1.25 0 102.5 0V8.75h-2.5z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5a1 1 0 00-1 1v1.958c0 .357.197.68.477.9A3.993 3.993 0 014 12a3.993 3.993 0 01-1.523 3.141c-.28.221-.477.544-.477.9V18a1 1 0 001 1h18a1 1 0 001-1v-1.958c0-.357-.197-.68-.477-.9A3.993 3.993 0 0120 12c0-1.274.595-2.409 1.523-3.141.28-.221.477-.544.477-.9V6a1 1 0 00-1-1H3zm6.25 2.25h5.5v1h2.5v.838c.001.68.003 1.635-.5 2.39-.5.75-1.361 1.15-2.61 1.248a2.752 2.752 0 01-1.39.92v1.604H15a.75.75 0 010 1.5H9a.75.75 0 010-1.5h2.25v-1.604a2.752 2.752 0 01-1.39-.92c-1.249-.097-2.11-.498-2.609-1.248-.503-.755-.502-1.71-.501-2.39V8.25h2.5v-1z",
    fill: "currentColor"
  })));
}
SvgTournamentTicketFilled.displayName = 'TournamentTicketFilled';
export default SvgTournamentTicketFilled;